import MuiChip from '@mui/material/Chip';
import { alpha, styled } from '@mui/material/styles';

import { Shade } from '../../../app/theming';
import { skillChipHeight } from '../skillChips/SkillChip';

import type { FunctionComponent, MouseEventHandler } from 'react';

const StyledMuiChip = styled(MuiChip)(({ theme }) => ({
    background: alpha(theme.palette.secondary.main, Shade.p12),
    color: theme.palette.secondary.contrastText,
    fontFamily: theme.typography.h6.fontFamily,
    fontSize: theme.typography.h6.fontSize,
    fontWeight: theme.typography.h6.fontWeight,
}));

type ExpandDataProps = { readonly label: string; readonly onClick?: MouseEventHandler | undefined };

export const ExpandOrCollapseDataButton: FunctionComponent<ExpandDataProps> = (props) => {
    const { label, onClick } = props;

    return <StyledMuiChip label={label} sx={{ borderRadius: '4px', height: skillChipHeight }} onClick={onClick} />;
};

type ChipOverviewProps = {
    readonly number: number;
    readonly onClick?: MouseEventHandler;
};

export const AdditionalItemsCountButton: FunctionComponent<ChipOverviewProps> = ({ number, onClick }) => (
    <ExpandOrCollapseDataButton label={`+${number}`} onClick={onClick} />
);
